import { useState, useEffect, useCallback } from "react";

/* ═══════════════════════════════════════════════════════
   CONFIG
═══════════════════════════════════════════════════════ */
const FB_KEY = "AIzaSyCVr6fxAQFhqOgf4I6_rhm9BF_pDXnCPao";
const FB_DB  = "https://loewenwolt-aa9a6-default-rtdb.europe-west1.firebasedatabase.app";
// Der private ICS-Link des Google-Kalenders steht bewusst nicht mehr hier:
// er waere im ausgelieferten Bundle lesbar. Er gehoert in das Apps Script,
// das den Kalender serverseitig abruft (Aufruf oben: ?action=calendar).
// Google Apps Script Webhook (nach Einrichtung eintragen):
const SHEETS_HOOK = "https://script.google.com/macros/s/AKfycbyJwtwLs_NtzFGVeSNbw9D8B9yF3NVA1n7N83hx6TPpaqjQl71YNzcef0RkoHwEuOEugQ/exec";

/*
 ╔══════════════════════════════════════════════════════╗
 ║  FIREBASE RTDB SICHERHEITSREGELN                     ║
 ║  Firebase Console → Realtime Database → Regeln:      ║
 ║  {                                                    ║
 ║    "rules": {                                         ║
 ║      "usernameIndex": { ".read": true,               ║
 ║                         ".write": false },            ║
 ║      ".read": "auth !== null",                        ║
 ║      ".write": "auth !== null"                        ║
 ║    }                                                  ║
 ║  }                                                    ║
 ╚══════════════════════════════════════════════════════╝
*/

/* ═══════════════════════════════════════════════════════
   GLOBAL CSS
═══════════════════════════════════════════════════════ */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Lora:ital,wght@0,400;0,500&display=swap');
*{box-sizing:border-box;margin:0;padding:0}
body{background:#0A1628;color:#F0EAD6;font-family:'Lora',Georgia,serif;-webkit-font-smoothing:antialiased}
input,select,textarea,button{font-family:inherit;outline:none}
::-webkit-scrollbar{width:3px}::-webkit-scrollbar-thumb{background:rgba(201,152,74,.3);border-radius:2px}
.c{font-family:'Cinzel','Times New Roman',serif}
@keyframes fi{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
@keyframes su{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:none}}
.fi{animation:fi .25s ease both}.su{animation:su .3s ease both}
.lw-inp{width:100%;background:rgba(255,255,255,.08);border:1px solid rgba(201,152,74,.25);border-radius:10px;padding:13px 16px;color:#F0EAD6;font-size:15px;transition:border-color .2s}
.lw-inp:focus{border-color:#C9984A}.lw-inp::placeholder{color:rgba(240,234,214,.4)}
.lw-sel{appearance:none;-webkit-appearance:none;width:100%;background:rgba(255,255,255,.08);border:1px solid rgba(201,152,74,.25);border-radius:10px;padding:13px 16px;color:#F0EAD6;font-size:15px}
.lw-sel option{background:#0D1F3C;color:#F0EAD6}
.lw-btn{display:block;width:100%;padding:14px;background:linear-gradient(135deg,#C9984A,#A07A30);color:#0A1628;border:none;border-radius:10px;font-family:'Cinzel',serif;font-size:14px;font-weight:700;letter-spacing:.06em;cursor:pointer;transition:opacity .2s,transform .1s}
.lw-btn:hover{opacity:.9}.lw-btn:active{transform:scale(.98)}.lw-btn:disabled{opacity:.5;cursor:default}
.lw-btn-o{background:transparent;color:#C9984A;border:1px solid rgba(201,152,74,.4)}.lw-btn-o:hover{background:rgba(201,152,74,.1)}
.lw-btn-r{background:linear-gradient(135deg,#C0392B,#922B21);color:#fff}
.lw-btn-g{background:linear-gradient(135deg,#27AE60,#1A7A40);color:#fff}
.card{background:rgba(255,255,255,.07);border:1px solid rgba(201,152,74,.15);border-radius:14px;padding:16px;margin-bottom:12px;cursor:pointer;transition:background .2s,border-color .2s}
.card:hover{background:rgba(201,152,74,.09);border-color:rgba(201,152,74,.3)}
.card-nc{cursor:default}.card-nc:hover{background:rgba(255,255,255,.07);border-color:rgba(201,152,74,.15)}
.divider{border:none;border-top:1px solid rgba(201,152,74,.1);margin:14px 0}
.sec-lbl{font-family:'Cinzel',serif;font-size:12px;letter-spacing:.1em;color:rgba(201,152,74,.85);text-transform:uppercase;margin:20px 0 8px}
.badge{display:inline-flex;align-items:center;padding:3px 10px;border-radius:20px;font-size:12px;font-family:'Cinzel',serif;letter-spacing:.04em}
.badge-g{background:rgba(39,174,96,.18);color:#52D68A;border:1px solid rgba(39,174,96,.3)}
.badge-r{background:rgba(231,76,60,.18);color:#F1948A;border:1px solid rgba(231,76,60,.3)}
.badge-y{background:rgba(243,156,18,.18);color:#F5CBA7;border:1px solid rgba(243,156,18,.3)}
.badge-b{background:rgba(52,152,219,.18);color:#85C1E9;border:1px solid rgba(52,152,219,.3)}
.badge-gold{background:rgba(201,152,74,.18);color:#E8C078;border:1px solid rgba(201,152,74,.3)}
.tag{display:inline-block;padding:3px 9px;border-radius:20px;font-size:12px;background:rgba(201,152,74,.12);color:#C9984A;border:1px solid rgba(201,152,74,.25)}
.spinner{width:20px;height:20px;border:2px solid rgba(201,152,74,.3);border-top-color:#C9984A;border-radius:50%;animation:spin .8s linear infinite;display:inline-block}
@keyframes spin{to{transform:rotate(360deg)}}
`;

/* ═══════════════════════════════════════════════════════
   FIREBASE AUTH REST
═══════════════════════════════════════════════════════ */
const AUTH = "https://identitytoolkit.googleapis.com/v1/accounts";

const fbSignIn = async (email, pw) => {
  const r = await fetch(`${AUTH}:signInWithPassword?key=${FB_KEY}`, {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({email, password:pw, returnSecureToken:true})
  });
  const d = await r.json();
  if (d.error) {
    const msg = d.error.message;
    if (msg==='EMAIL_NOT_FOUND'||msg==='INVALID_EMAIL') throw new Error('Unbekannte E-Mail.');
    if (msg==='WRONG_PASSWORD'||msg==='INVALID_PASSWORD') throw new Error('Falsches Passwort.');
    if (msg==='USER_DISABLED') throw new Error('Konto deaktiviert. Bitte Admin kontaktieren.');
    throw new Error(msg);
  }
  return d; // {idToken, localId, email, refreshToken}
};

const fbCreateUser = async (email, pw) => {
  const r = await fetch(`${AUTH}:signUp?key=${FB_KEY}`, {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({email, password:pw, returnSecureToken:true})
  });
  const d = await r.json();
  if (d.error) throw new Error(d.error.message);
  return d;
};

const fbChangePassword = async (idToken, newPw) => {
  const r = await fetch(`${AUTH}:update?key=${FB_KEY}`, {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({idToken, password:newPw, returnSecureToken:true})
  });
  const d = await r.json();
  if (d.error) throw new Error(d.error.message);
  return d;
};

const fbSendReset = async (email) => {
  const r = await fetch(`${AUTH}:sendOobCode?key=${FB_KEY}`, {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({requestType:'PASSWORD_RESET', email})
  });
  const d = await r.json();
  if (d.error) throw new Error(d.error.message);
  return d;
};

/* ═══════════════════════════════════════════════════════
   REALTIME DATABASE REST
═══════════════════════════════════════════════════════ */
const dbRead = async (path, token) => {
  const url = `${FB_DB}/${path}.json${token?`?auth=${token}`:''}`;
  const r = await fetch(url);
  if (!r.ok) throw new Error(`DB-Fehler: ${r.status}`);
  return r.json();
};

const dbWrite = async (path, data, token) => {
  const r = await fetch(`${FB_DB}/${path}.json?auth=${token}`, {
    method:'PUT', headers:{'Content-Type':'application/json'},
    body: JSON.stringify(data)
  });
  const d = await r.json();
  if (d && d.error) throw new Error(d.error);
  return d;
};

const dbUpdate = async (path, data, token) => {
  const r = await fetch(`${FB_DB}/${path}.json?auth=${token}`, {
    method:'PATCH', headers:{'Content-Type':'application/json'},
    body: JSON.stringify(data)
  });
  const d = await r.json();
  if (d && d.error) throw new Error(d.error);
  return d;
};

const dbPush = async (path, data, token) => {
  const r = await fetch(`${FB_DB}/${path}.json?auth=${token}`, {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify(data)
  });
  const d = await r.json();
  if (d && d.error) throw new Error(d.error);
  return d; // {name: "-AutoID"}
};

const dbRemove = async (path, token) => {
  await fetch(`${FB_DB}/${path}.json?auth=${token}`, { method:'DELETE' });
};

/* ═══════════════════════════════════════════════════════
   GOOGLE CALENDAR — über Apps Script Proxy (umgeht CORS)
═══════════════════════════════════════════════════════ */
const fetchCalendarEvents = async () => {
  // Über den Apps-Script-Proxy: der ruft den Kalender serverseitig ab, damit
  // weder CORS im Weg steht noch der private Kalenderlink im Bundle landet.
  if (SHEETS_HOOK) {
    try {
      const r = await fetch(`${SHEETS_HOOK}?action=calendar`);
      const d = await r.json();
      if (d.ok && Array.isArray(d.events)) {
        return d.events.map(e=>({
          ...e,
          date: e.dateStr ? new Date(e.dateStr) : null
        }));
      }
    } catch(e){ /* unten leere Liste */ }
  }
  // Ohne den Proxy keine Termine. Ein direkter Abruf des privaten ICS-Links
  // wuerde an CORS scheitern und den Link ausserdem im Bundle offenlegen.
  return [];
};

/* ═══════════════════════════════════════════════════════
   IMPORT-DATEN (alle Mitglieder aus Excel)
═══════════════════════════════════════════════════════ */
/* Die Mitgliederdaten standen frueher an dieser Stelle im Quelltext.
   Das hatte zwei Nachteile: sie landeten im ausgelieferten JavaScript-Bundle,
   wo jeder Besucher sie ohne Anmeldung lesen konnte, und im git-Repository.
   Fuer die Ersteinrichtung wird die Liste jetzt im Ersteinrichtungs-Bildschirm
   als JSON-Datei ausgewaehlt und nur im Browser gelesen - sie wird nie gebaut
   und nie hochgeladen. Aufbau der Datei: eine Liste von Objekten mit den
   Feldern username, initPw, role, mustChange, firstName, lastName, title,
   email, phoneMobile, phonePrivate, phoneWork, street, zip, city, birthdate,
   birthplace, profession, company, companyAddress, grade, status, igld,
   partner, partnerBirthdate, gradeDates. */

/* ═══════════════════════════════════════════════════════
   UTILS + CONSTANTS
═══════════════════════════════════════════════════════ */
const GRADES=['','Ovaten-Grad (I)','Barden-Grad (II)','Druiden-Grad (III)','Kapitel-Grad (IV)','Ring-Grad (V)','Alt-Erz-Grad (VI)','Ritter-Grad (VII)'];
const GRADE_SHORT=['','I','II','III','IV','V','VI','VII'];
const GRADE_COLOR=['','#8A7A6A','#A09020','#507050','#C9984A','#6060A0','#8A3030','#9A6040'];

const fmtDate = s => s ? new Date(s).toLocaleDateString('de-DE',{day:'2-digit',month:'2-digit',year:'numeric'}) : '';
const daysUntil = s => Math.ceil((new Date(s)-new Date())/(864e5));
const initials = (f,l) => ((f||'')[0]||'').toUpperCase()+((l||'')[0]||'').toUpperCase();
const nowISO = () => new Date().toISOString().slice(0,10);

// Kalender-Titel aufräumen: "Loge • I: Br. X | A: Br. Y" → lesbare Anzeige
const cleanCalTitle = (t='') => {
  let s = t.replace(/^Loge\s*[•:]\s*/i,'').trim();
  return s || t;
};

const sheetsLog = async (type, data) => {
  if (!SHEETS_HOOK) return;
  try { await fetch(SHEETS_HOOK, {method:'POST',body:JSON.stringify({type,...data}),headers:{'Content-Type':'application/json'}}); } catch {}
};

/* ═══════════════════════════════════════════════════════
   UI ATOMS
═══════════════════════════════════════════════════════ */
function StarLogo({size=64}){
  const pts=[], cx=50,cy=50,oR=44,iR=18;
  for(let i=0;i<14;i++){
    const r=i%2===0?oR:iR, a=(i*Math.PI/7)-Math.PI/2;
    pts.push(`${(cx+r*Math.cos(a)).toFixed(1)},${(cy+r*Math.sin(a)).toFixed(1)}`);
  }
  return(
    <svg width={size} height={size} viewBox="0 0 100 100" style={{flexShrink:0}}>
      <defs>
        <linearGradient id="sg" x1="20%" y1="0%" x2="80%" y2="100%">
          <stop offset="0%" stopColor="#F0D070"/>
          <stop offset="50%" stopColor="#C9984A"/>
          <stop offset="100%" stopColor="#7A5A20"/>
        </linearGradient>
      </defs>
      <polygon points={pts.join(' ')} fill="url(#sg)" style={{filter:'drop-shadow(0 2px 8px rgba(201,152,74,.5))'}}/>
      <circle cx={50} cy={50} r={8} fill="rgba(255,240,180,.6)"/>
    </svg>
  );
}

function Avatar({member,size=42}){
  if(member?.photo) return <img src={member.photo} alt="" style={{width:size,height:size,borderRadius:'50%',objectFit:'cover',border:'1.5px solid rgba(201,152,74,.4)',flexShrink:0}}/>;
  return(
    <div style={{width:size,height:size,borderRadius:'50%',background:'rgba(201,152,74,.15)',border:'1.5px solid rgba(201,152,74,.35)',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:"'Cinzel',serif",fontSize:size>40?14:11,fontWeight:600,color:'#C9984A',flexShrink:0}}>
      {initials(member?.firstName,member?.lastName)}
    </div>
  );
}

function GradeBadge({grade}){
  if(!grade) return null;
  return <span style={{display:'inline-flex',alignItems:'center',padding:'2px 8px',borderRadius:20,fontSize:12,fontFamily:"'Cinzel',serif",background:`${GRADE_COLOR[grade]}22`,color:GRADE_COLOR[grade],border:`1px solid ${GRADE_COLOR[grade]}44`}}>{GRADE_SHORT[grade]}</span>;
}

function Toast({msg}){
  if(!msg) return null;
  return <div style={{position:'fixed',bottom:90,left:'50%',transform:'translateX(-50%)',background:'rgba(201,152,74,.95)',color:'#0A1628',padding:'10px 22px',borderRadius:24,fontSize:13,fontFamily:"'Cinzel',serif",letterSpacing:'.03em',whiteSpace:'nowrap',zIndex:999,animation:'fi .3s ease',pointerEvents:'none'}}>{msg}</div>;
}

function Spinner(){
  return <div style={{display:'flex',alignItems:'center',justifyContent:'center',padding:40}}><div className="spinner"/></div>;
}

/* ═══════════════════════════════════════════════════════
   SCREEN: LOGIN
═══════════════════════════════════════════════════════ */
function LoginScreen({onLogin}){
  const [user,setUser]=useState('');
  const [pass,setPass]=useState('');
  const [err,setErr]=useState('');
  const [loading,setLoading]=useState(false);
  const [resetMode,setResetMode]=useState(false);
  const [resetEmail,setResetEmail]=useState('');
  const [resetMsg,setResetMsg]=useState('');

  const doLogin = async () => {
    setErr(''); setLoading(true);
    try {
      let email = user.trim();
      // Wenn kein @: Username-Lookup in RTDB (öffentlich lesbar)
      if (!email.includes('@')) {
        const lookup = await dbRead(`usernameIndex/${email}`);
        if (!lookup) throw new Error('Benutzername nicht gefunden. Bei Erstanmeldung bitte E-Mail verwenden.');
        email = lookup.email;
      }
      const auth = await fbSignIn(email, pass);
      const profile = await dbRead(`members/${auth.localId}`, auth.idToken);
      onLogin(auth, profile || null);
    } catch(e) { setErr(e.message); }
    finally { setLoading(false); }
  };

  const doReset = async () => {
    if (!resetEmail) return;
    setLoading(true);
    try {
      await fbSendReset(resetEmail);
      setResetMsg('E-Mail gesendet. Bitte Postfach prüfen.');
    } catch(e) { setErr(e.message); }
    finally { setLoading(false); }
  };

  return(
    <div className="fi" style={{minHeight:'100vh',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'32px 28px',background:'linear-gradient(180deg,#0A1628 0%,#0D1F3C 100%)'}}>
      <div style={{position:'absolute',width:300,height:300,borderRadius:'50%',border:'1px solid rgba(201,152,74,.06)',top:'8%',left:'50%',transform:'translateX(-50%)',pointerEvents:'none'}}/>
      <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:12,marginBottom:36}}>
        <StarLogo size={72}/>
        <div style={{textAlign:'center'}}>
          <div className="c" style={{fontSize:22,fontWeight:700,letterSpacing:'.1em',color:'#E8C078',lineHeight:1.2}}>LOEWENWOLT</div>
          <div className="c" style={{fontSize:10,letterSpacing:'.2em',color:'rgba(201,152,74,.7)',marginTop:4}}>LOGE · MITGLIEDERPORTAL</div>
        </div>
      </div>

      {!resetMode ? (
        <div style={{width:'100%',maxWidth:360,display:'flex',flexDirection:'column',gap:14}}>
          <div>
            <div className="c" style={{fontSize:11,letterSpacing:'.1em',color:'rgba(240,234,214,.6)',marginBottom:6}}>BENUTZERNAME ODER E-MAIL</div>
            <input className="lw-inp" value={user} onChange={e=>setUser(e.target.value)}
              placeholder="z.B. wilhelmbauck" onKeyDown={e=>e.key==='Enter'&&doLogin()}/>
          </div>
          <div>
            <div className="c" style={{fontSize:11,letterSpacing:'.1em',color:'rgba(240,234,214,.6)',marginBottom:6}}>PASSWORT</div>
            <input className="lw-inp" type="password" value={pass} onChange={e=>setPass(e.target.value)}
              placeholder="••••••••" onKeyDown={e=>e.key==='Enter'&&doLogin()}/>
          </div>
          {err&&<div style={{fontSize:13,color:'#F1948A',textAlign:'center',padding:'4px 0'}}>{err}</div>}
          <button className="lw-btn" onClick={doLogin} disabled={loading} style={{marginTop:4}}>
            {loading?<span><span className="spinner" style={{width:16,height:16,borderWidth:2}}/></span>:'Anmelden →'}
          </button>
          <button onClick={()=>{setResetMode(true);setErr('');}} style={{background:'none',border:'none',color:'rgba(201,152,74,.65)',fontSize:13,cursor:'pointer',letterSpacing:'.02em'}}>
            Passwort vergessen?
          </button>
        </div>
      ) : (
        <div style={{width:'100%',maxWidth:360,display:'flex',flexDirection:'column',gap:14}}>
          <div className="c" style={{fontSize:13,color:'#E8C078',letterSpacing:'.06em',marginBottom:4}}>PASSWORT ZURÜCKSETZEN</div>
          <div style={{fontSize:14,color:'rgba(240,234,214,.8)',lineHeight:1.6,marginBottom:4}}>
            Bitte E-Mail-Adresse eingeben. Du erhältst einen Reset-Link.
          </div>
          <input className="lw-inp" type="email" value={resetEmail} onChange={e=>setResetEmail(e.target.value)} placeholder="deine@email.de"/>
          {err&&<div style={{fontSize:13,color:'#F1948A'}}>{err}</div>}
          {resetMsg&&<div style={{fontSize:13,color:'#52D68A'}}>{resetMsg}</div>}
          <button className="lw-btn" onClick={doReset} disabled={loading}>Reset-E-Mail senden</button>
          <button className="lw-btn lw-btn-o" onClick={()=>{setResetMode(false);setErr('');setResetMsg('');}}>Zurück</button>
        </div>
      )}

      <div style={{position:'absolute',bottom:24,fontSize:11,color:'rgba(240,234,214,.25)',fontFamily:"'Cinzel',serif",letterSpacing:'.08em'}}>LOGE LOEWENWOLT · UELZEN</div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════
   SCREEN: CHANGE PASSWORD
═══════════════════════════════════════════════════════ */
function ChangePasswordScreen({auth,onDone}){
  const [p1,setP1]=useState('');
  const [p2,setP2]=useState('');
  const [err,setErr]=useState('');
  const [loading,setLoading]=useState(false);

  const save = async () => {
    if(p1.length<8){setErr('Mindestens 8 Zeichen.');return;}
    if(p1!==p2){setErr('Passwörter stimmen nicht überein.');return;}
    setLoading(true);
    try {
      const res = await fbChangePassword(auth.idToken, p1);
      // mustChange auf false setzen
      await dbUpdate(`members/${auth.localId}`, {mustChange:false}, res.idToken||auth.idToken);
      onDone(res.idToken||auth.idToken);
    } catch(e){setErr(e.message);}
    finally{setLoading(false);}
  };

  return(
    <div className="fi" style={{minHeight:'100vh',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'32px 28px',background:'linear-gradient(180deg,#0A1628 0%,#0D1F3C 100%)'}}>
      <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:10,marginBottom:32}}>
        <StarLogo size={52}/>
        <div className="c" style={{fontSize:16,fontWeight:600,letterSpacing:'.08em',color:'#E8C078',textAlign:'center'}}>PASSWORT ÄNDERN</div>
        <div style={{fontSize:14,color:'rgba(240,234,214,.8)',textAlign:'center',maxWidth:280,lineHeight:1.6}}>
          Bitte bei der Erstanmeldung ein eigenes Passwort setzen.
        </div>
      </div>
      <div style={{width:'100%',maxWidth:360,display:'flex',flexDirection:'column',gap:14}}>
        <div>
          <div className="c" style={{fontSize:11,letterSpacing:'.1em',color:'rgba(240,234,214,.6)',marginBottom:6}}>NEUES PASSWORT (mind. 8 Zeichen)</div>
          <input className="lw-inp" type="password" value={p1} onChange={e=>setP1(e.target.value)} placeholder="Neues Passwort"/>
        </div>
        <div>
          <div className="c" style={{fontSize:11,letterSpacing:'.1em',color:'rgba(240,234,214,.6)',marginBottom:6}}>PASSWORT BESTÄTIGEN</div>
          <input className="lw-inp" type="password" value={p2} onChange={e=>setP2(e.target.value)} placeholder="Wiederholen"/>
        </div>
        {err&&<div style={{fontSize:13,color:'#F1948A',textAlign:'center'}}>{err}</div>}
        <button className="lw-btn" onClick={save} disabled={loading} style={{marginTop:4}}>
          {loading?'Speichern...':'Passwort speichern →'}
        </button>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════
   SCREEN: ERSTEINRICHTUNG (Admin-Import)
═══════════════════════════════════════════════════════ */
function SetupScreen({auth,onDone}){
  const [importing,setImporting]=useState(false);
  const [rows,setRows]=useState([]);
  const [dateiname,setDateiname]=useState('');
  const [progress,setProgress]=useState('');
  const [done,setDone]=useState(false);
  const [err,setErr]=useState('');

  // Mitgliederliste aus einer lokalen JSON-Datei lesen. Die Datei bleibt im
  // Browser, sie wird weder gebaut noch hochgeladen.
  const dateiLesen = (e) => {
    const f = e.target.files && e.target.files[0];
    if(!f) return;
    const leser = new FileReader();
    leser.onload = () => {
      try {
        const daten = JSON.parse(leser.result);
        if(!Array.isArray(daten)) throw new Error('Die Datei muss eine Liste von Mitgliedern enthalten.');
        if(!daten.length) throw new Error('Die Liste ist leer.');
        if(!daten[0].username || !daten[0].email) throw new Error('Den Eintraegen fehlen username oder email.');
        setRows(daten); setDateiname(f.name); setErr('');
      } catch(ex){ setRows([]); setDateiname(''); setErr('Datei nicht lesbar: '+ex.message); }
    };
    leser.readAsText(f);
  };

  const runImport = async () => {
    setImporting(true); setErr('');
    try {
      const members = {};
      const usernameIndex = {};
      // E-Mail des aktuell eingeloggten Admins (Kleinschreibung für Vergleich)
      const myEmail = (auth.email||'').toLowerCase();

      for(let i=0; i<rows.length; i++){
        const m = rows[i];
        setProgress(`${i+1}/${rows.length}: ${m.firstName} ${m.lastName} …`);
        const {initPw, ...profile} = m;

        // Fall 1: Dieser Datensatz ist der bereits eingeloggte Admin
        // → vorhandene UID nutzen, KEINEN neuen Account anlegen
        if (m.email.toLowerCase() === myEmail) {
          const uid = auth.localId;
          members[uid] = {...profile, uid, photo:null, mustChange:false, createdAt: nowISO()};
          usernameIndex[m.username] = {uid, email: m.email};
          continue;
        }

        // Fall 2: Neuer Account
        try {
          const fbUser = await fbCreateUser(m.email, m.initPw);
          const uid = fbUser.localId;
          members[uid] = {...profile, uid, photo:null, createdAt: nowISO()};
          usernameIndex[m.username] = {uid, email: m.email};
          await new Promise(r=>setTimeout(r,300));
        } catch(e){
          // Falls Account schon existiert (z.B. zweiter Import-Versuch):
          // trotzdem Profil per Username-Login-E-Mail eintragen ist nicht möglich
          // ohne UID — daher überspringen und melden.
          setProgress(`⚠ ${m.firstName} ${m.lastName}: ${e.message} (übersprungen)`);
          await new Promise(r=>setTimeout(r,500));
        }
      }

      setProgress('Schreibe Datenbank …');
      await dbWrite('members', members, auth.idToken);
      await dbWrite('usernameIndex', usernameIndex, auth.idToken);
      // Sheets-Log des Imports
      await sheetsLog('memberImport', {members: Object.values(members)});
      setDone(true);
      setProgress(`Import abgeschlossen ✓ (${Object.keys(members).length} Profile)`);
    } catch(e){ setErr(e.message); }
    finally{ setImporting(false); }
  };

  return(
    <div className="fi" style={{minHeight:'100vh',display:'flex',flexDirection:'column',alignItems:'center',padding:'48px 28px',background:'linear-gradient(180deg,#0A1628,#0D1F3C)'}}>
      <StarLogo size={56}/>
      <div className="c" style={{fontSize:16,fontWeight:600,color:'#E8C078',letterSpacing:'.08em',margin:'16px 0 8px',textAlign:'center'}}>ERSTEINRICHTUNG</div>
      <div style={{fontSize:14,color:'rgba(240,234,214,.85)',textAlign:'center',maxWidth:320,lineHeight:1.7,marginBottom:28}}>
        Die Datenbank ist leer. Waehle die Mitgliederdatei (JSON) aus - sie wird nur hier im Browser gelesen. Firebase Auth-Konten werden dabei angelegt.
      </div>

      <div style={{width:'100%',maxWidth:360}}>
        <label className="lw-inp" style={{display:'block',textAlign:'center',cursor:'pointer',marginBottom:16}}>
          {dateiname ? dateiname : 'Mitgliederdatei waehlen (.json)'}
          <input type="file" accept="application/json,.json" onChange={dateiLesen} style={{display:'none'}}/>
        </label>

        {rows.length>0 && (
        <div style={{padding:16,background:'rgba(255,255,255,.05)',borderRadius:12,border:'1px solid rgba(201,152,74,.15)',marginBottom:16}}>
          <div className="c" style={{fontSize:11,letterSpacing:'.08em',color:'rgba(201,152,74,.8)',marginBottom:8}}>WIRD IMPORTIERT ({rows.length})</div>
          {rows.slice(0,5).map(m=>(
            <div key={m.username} style={{fontSize:13,color:'rgba(240,234,214,.75)',padding:'3px 0'}}>
              {m.firstName} {m.lastName} — {m.username}
            </div>
          ))}
          {rows.length>5 && <div style={{fontSize:12,color:'rgba(240,234,214,.5)',marginTop:6}}>... und {rows.length-5} weitere</div>}
        </div>
        )}

        {progress&&(
          <div style={{padding:12,background:'rgba(201,152,74,.08)',borderRadius:8,border:'1px solid rgba(201,152,74,.2)',marginBottom:12,fontSize:13,color:'#E8C078',fontFamily:"'Cinzel',serif",letterSpacing:'.03em'}}>
            {progress}
          </div>
        )}
        {err&&<div style={{fontSize:13,color:'#F1948A',marginBottom:12}}>{err}</div>}

        {!done ? (
          <button className="lw-btn" onClick={runImport} disabled={importing || rows.length===0}>
            {importing?'Importiere …':'Mitglieder importieren →'}
          </button>
        ) : (
          <button className="lw-btn lw-btn-g" onClick={onDone}>App starten →</button>
        )}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════
   SCREEN: DASHBOARD
═══════════════════════════════════════════════════════ */
function DashboardScreen({user,events,calEvents,bulletins,setView,setSelEvent}){
  // Termine: App-Events + Kalender-Events zusammenführen, nächste 3
  const allEvents = [
    ...events.map(e=>({...e,source:'app'})),
    ...calEvents.filter(c=>!events.find(e=>e.date===c.dateStr||e.title===c.title)).map(c=>({
      id:c.uid||`cal-${c.title}`,title:cleanCalTitle(c.title),date:c.dateStr,
      time:c.time||'19:00',
      location:c.location||'',description:c.description||'',source:'calendar',rsvps:{}
    }))
  ].filter(e=>new Date(e.date)>=new Date())
   .sort((a,b)=>new Date(a.date)-new Date(b.date))
   .slice(0,3);

  const pinned=bulletins.filter(b=>b.pinned);
  const dDays=n=>n<=0?'Heute':n<=7?<span style={{color:'#E74C3C'}}>{n}</span>:n<=14?<span style={{color:'#F39C12'}}>{n}</span>:<span style={{color:'#C9984A'}}>{n}</span>;

  return(
    <div className="fi" style={{padding:'0 0 80px'}}>
      <div style={{background:'linear-gradient(180deg,#0D1F3C,#0A1628)',padding:'48px 24px 28px',borderBottom:'1px solid rgba(201,152,74,.1)'}}>
        <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:8}}>
          <StarLogo size={32}/>
          <div>
            <div className="c" style={{fontSize:11,letterSpacing:'.15em',color:'rgba(201,152,74,.7)'}}>LOGE LOEWENWOLT</div>
            <div className="c" style={{fontSize:16,fontWeight:600,color:'#E8C078',letterSpacing:'.05em'}}>Willkommen, Br. {user.firstName}</div>
          </div>
        </div>
        <div style={{display:'flex',gap:8,marginTop:12,flexWrap:'wrap'}}>
          <GradeBadge grade={user.grade}/>
          {user.role==='admin'&&<span className="badge badge-b">Admin</span>}
          <span className="badge badge-g">aktiv</span>
        </div>
      </div>

      <div style={{padding:'0 20px'}}>
        {pinned.length>0&&(
          <div onClick={()=>setView('bulletin')} style={{marginTop:20,padding:16,background:'rgba(201,152,74,.07)',border:'1px solid rgba(201,152,74,.28)',borderRadius:12,cursor:'pointer'}}>
            <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:6}}>
              <span className="c" style={{fontSize:10,letterSpacing:'.1em',color:'#C9984A'}}>📌 PINNWAND</span>
            </div>
            <div style={{fontSize:14,fontWeight:500,color:'#F0EAD6',marginBottom:4}}>{pinned[0].title}</div>
            <div style={{fontSize:13,color:'rgba(240,234,214,.8)',lineHeight:1.5,overflow:'hidden',display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical'}}>{pinned[0].content}</div>
          </div>
        )}

        <div className="sec-lbl" style={{marginTop:24}}>
          Nächste Termine
          {calEvents.length>0&&<span style={{fontFamily:'Lora',fontSize:11,color:'rgba(201,152,74,.6)',letterSpacing:0,marginLeft:6,textTransform:'none'}}>· Google Kalender ✓</span>}
        </div>

        {allEvents.length===0&&(
          <div style={{padding:20,textAlign:'center',color:'rgba(240,234,214,.6)',fontSize:14}}>Keine bevorstehenden Termine</div>
        )}

        {allEvents.map((ev,i)=>{
          const days=daysUntil(ev.date);
          const myRsvp=ev.rsvps?.[user.uid];
          return(
            <div key={ev.id} className="card fi" style={{animationDelay:`${i*.07}s`}} onClick={()=>{if(ev.source==='app'){setSelEvent(ev.id);setView('eventDetail');}}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
                <div style={{flex:1}}>
                  {ev.source==='calendar'&&<span className="tag" style={{fontSize:11,marginBottom:6,display:'inline-block'}}>Kalender</span>}
                  <div className="c" style={{fontSize:14,fontWeight:600,color:'#E8C078',marginBottom:4}}>{ev.title}</div>
                  <div style={{fontSize:13,color:'rgba(240,234,214,.85)'}}>
                    {fmtDate(ev.date)} · {ev.time} Uhr
                  </div>
                  {ev.location&&<div style={{fontSize:13,color:'rgba(240,234,214,.75)',marginTop:3}}>{ev.location}</div>}
                </div>
                <div style={{textAlign:'right',flexShrink:0,marginLeft:12}}>
                  <div className="c" style={{fontSize:22,fontWeight:700,lineHeight:1}}>{dDays(days)}</div>
                  <div className="c" style={{fontSize:10,letterSpacing:'.08em',color:'rgba(240,234,214,.55)'}}>TAGE</div>
                </div>
              </div>
              {myRsvp&&(
                <span className={`badge ${myRsvp.type==='no'?'badge-r':myRsvp.type==='maybe'?'badge-y':'badge-g'}`} style={{fontSize:11,marginTop:8}}>
                  {myRsvp.type==='no'?'Abgesagt':myRsvp.type==='maybe'?'Vielleicht':'Zugesagt'}
                </span>
              )}
            </div>
          );
        })}
        <button className="lw-btn lw-btn-o" style={{marginTop:4}} onClick={()=>setView('events')}>Alle Termine →</button>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════
   MODAL: RSVP
═══════════════════════════════════════════════════════ */
function RsvpModal({event,user,onSave,onClose}){
  const existing=event.rsvps?.[user.uid];
  const [type,setType]=useState(existing?.type||'');
  const [partnerName,setPartnerName]=useState(existing?.partnerName||user.partner||'');
  const [guestName,setGuestName]=useState(existing?.guestName||'');

  const opts=[
    {k:'yes',l:'Zusage',i:'✓'},
    {k:'yes_partner',l:'Mit Partnerin',i:'✓+P'},
    ...(event.forGuests?[{k:'yes_guest',l:'Mit Gast',i:'✓+G'}]:[]),
    {k:'maybe',l:'Vielleicht',i:'?'},
    {k:'no',l:'Absage',i:'✗'},
  ];

  return(
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.78)',display:'flex',alignItems:'flex-end',justifyContent:'center',zIndex:200}}>
      <div className="su" style={{width:'100%',maxWidth:480,background:'#111E35',borderRadius:'20px 20px 0 0',border:'1px solid rgba(201,152,74,.2)',padding:'24px 24px 40px'}}>
        <div style={{width:36,height:4,background:'rgba(201,152,74,.3)',borderRadius:2,margin:'0 auto 20px'}}/>
        <div className="c" style={{fontSize:14,fontWeight:600,color:'#E8C078',letterSpacing:'.06em',marginBottom:4}}>RÜCKMELDUNG</div>
        <div style={{fontSize:14,color:'rgba(240,234,214,.85)',marginBottom:20}}>{event.title}</div>
        <div style={{display:'flex',gap:8,flexWrap:'wrap',marginBottom:20}}>
          {opts.map(o=>(
            <button key={o.k} onClick={()=>setType(o.k)} style={{flex:'1 1 calc(33% - 8px)',minWidth:80,padding:'10px 6px',borderRadius:10,border:`1px solid ${type===o.k?'rgba(201,152,74,.6)':'rgba(201,152,74,.18)'}`,background:type===o.k?'rgba(201,152,74,.18)':'transparent',color:type===o.k?'#E8C078':'rgba(240,234,214,.8)',fontFamily:"'Lora',serif",fontSize:13,cursor:'pointer',transition:'all .2s'}}>
              <div style={{fontWeight:600,marginBottom:2}}>{o.i}</div>{o.l}
            </button>
          ))}
        </div>
        {type==='yes_partner'&&<div style={{marginBottom:16}}><div className="c" style={{fontSize:11,letterSpacing:'.1em',color:'rgba(240,234,214,.6)',marginBottom:6}}>NAME PARTNERIN</div><input className="lw-inp" value={partnerName} onChange={e=>setPartnerName(e.target.value)} placeholder="Vorname"/></div>}
        {type==='yes_guest'&&<div style={{marginBottom:16}}><div className="c" style={{fontSize:11,letterSpacing:'.1em',color:'rgba(240,234,214,.6)',marginBottom:6}}>NAME GAST</div><input className="lw-inp" value={guestName} onChange={e=>setGuestName(e.target.value)} placeholder="Vor- und Nachname"/></div>}
        {type&&<button className="lw-btn" onClick={()=>onSave({type,partnerName,guestName})} style={{marginBottom:10}}>Speichern</button>}
        <button className="lw-btn lw-btn-o" onClick={onClose}>Abbrechen</button>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════
   SCREEN: EVENTS
═══════════════════════════════════════════════════════ */
function EventsScreen({events,calEvents,user,setView,setSelEvent}){
  // App-Events (mit RSVP) + Kalender-Events (nur Anzeige) zusammenführen
  const merged = [
    ...events.map(e=>({...e,source:'app'})),
    ...(calEvents||[]).filter(c=>!events.find(e=>e.date===c.dateStr)).map(c=>({
      id:c.uid||`cal-${c.dateStr}-${c.title}`,
      title:cleanCalTitle(c.title),date:c.dateStr,time:c.time||'',
      location:c.location||'',description:c.description||'',source:'calendar',rsvps:{}
    }))
  ];
  const upcoming=merged.filter(e=>new Date(e.date)>=new Date()).sort((a,b)=>new Date(a.date)-new Date(b.date));
  const past=merged.filter(e=>new Date(e.date)<new Date()).sort((a,b)=>new Date(b.date)-new Date(a.date)).slice(0,20);

  const Card=({ev})=>{
    const days=daysUntil(ev.date); const isPast=days<0;
    const myRsvp=ev.rsvps?.[user.uid];
    const isCal=ev.source==='calendar';
    return(
      <div className="card" onClick={()=>{ if(!isCal){setSelEvent(ev.id);setView('eventDetail');} }} style={isCal?{cursor:'default'}:{}}>
        <div style={{display:'flex',justifyContent:'space-between',gap:12}}>
          <div style={{flex:1}}>
            <div style={{display:'flex',gap:6,marginBottom:6,flexWrap:'wrap'}}>
              {isCal&&<span className="tag" style={{fontSize:11}}>Kalender</span>}
              {ev.forGuests&&<span className="tag" style={{fontSize:11}}>Gäste</span>}
            </div>
            <div className="c" style={{fontSize:13,fontWeight:600,color:isPast?'rgba(240,234,214,.5)':'#E8C078',marginBottom:4}}>{ev.title}</div>
            <div style={{fontSize:13,color:'rgba(240,234,214,.85)'}}>{fmtDate(ev.date)}{ev.time?` · ${ev.time} Uhr`:''}</div>
            {ev.location&&<div style={{fontSize:13,color:'rgba(240,234,214,.75)',marginTop:2}}>{ev.location}</div>}
          </div>
          <div style={{textAlign:'right',flexShrink:0}}>
            {!isPast&&<div className="c" style={{fontSize:18,fontWeight:700,color:days<=7?'#E74C3C':days<=14?'#F39C12':'#C9984A'}}>{days}d</div>}
            {myRsvp&&<span className={`badge ${myRsvp.type==='no'?'badge-r':myRsvp.type==='maybe'?'badge-y':'badge-g'}`} style={{fontSize:11,marginTop:4}}>
              {myRsvp.type==='no'?'✗':myRsvp.type==='maybe'?'?':'✓'}
            </span>}
          </div>
        </div>
      </div>
    );
  };

  return(
    <div className="fi" style={{padding:'0 0 80px'}}>
      <div style={{padding:'48px 20px 16px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <div className="c" style={{fontSize:18,fontWeight:700,color:'#E8C078',letterSpacing:'.06em'}}>TERMINE</div>
        <button onClick={()=>setView('createEvent')} style={{display:'flex',alignItems:'center',gap:6,background:'rgba(201,152,74,.15)',border:'1px solid rgba(201,152,74,.3)',borderRadius:24,padding:'7px 14px',color:'#C9984A',fontFamily:"'Cinzel',serif",fontSize:11,letterSpacing:'.06em',cursor:'pointer'}}>
          + NEU
        </button>
      </div>
      <div style={{padding:'0 20px'}}>
        {upcoming.length>0
          ?<><div className="sec-lbl">Bevorstehend</div>{upcoming.map(ev=><Card key={ev.id} ev={ev}/>)}</>
          :<div style={{padding:20,textAlign:'center',color:'rgba(240,234,214,.6)',fontSize:14}}>Keine bevorstehenden Termine</div>}
        {past.length>0&&<><div className="sec-lbl">Vergangen</div>{past.map(ev=><Card key={ev.id} ev={ev}/>)}</>}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════
   SCREEN: EVENT DETAIL + RSVP
═══════════════════════════════════════════════════════ */
function EventDetailScreen({event,user,members,token,onUpdateRsvp,onBack}){
  const [showRsvp,setShowRsvp]=useState(false);
  const [saving,setSaving]=useState(false);
  const [toast,setToast]=useState('');
  const showToast=m=>{setToast(m);setTimeout(()=>setToast(''),2500);};
  const days=daysUntil(event.date); const isPast=days<0;
  const myRsvp=event.rsvps?.[user.uid];

  const saveRsvp = async (rsvp) => {
    setSaving(true);
    try {
      await dbWrite(`rsvps/${event.id}/${user.uid}`, rsvp, token);
      onUpdateRsvp(event.id, user.uid, rsvp);
      await sheetsLog('rsvp',{eventId:event.id,eventTitle:event.title,uid:user.uid,name:`${user.firstName} ${user.lastName}`,...rsvp,date:nowISO()});
      setShowRsvp(false); showToast('Rückmeldung gespeichert ✓');
    } catch(e){showToast('Fehler: '+e.message);}
    finally{setSaving(false);}
  };

  const rsvpList=Object.entries(event.rsvps||{}).map(([uid,r])=>{
    const m=members.find(m=>m.uid===uid);
    return m?{member:m,rsvp:r}:null;
  }).filter(Boolean);

  const yes=rsvpList.filter(r=>['yes','yes_partner','yes_guest'].includes(r.rsvp.type));
  const maybe=rsvpList.filter(r=>r.rsvp.type==='maybe');
  const no=rsvpList.filter(r=>r.rsvp.type==='no');

  return(
    <>
    <Toast msg={toast}/>
    <div className="fi" style={{padding:'0 0 80px'}}>
      <div style={{background:'linear-gradient(180deg,#0D1F3C,#0A1628)',padding:'48px 20px 24px'}}>
        <button onClick={onBack} style={{display:'flex',alignItems:'center',gap:6,background:'none',border:'none',color:'rgba(201,152,74,.7)',fontSize:13,cursor:'pointer',marginBottom:16}}>
          ← Zurück
        </button>
        <div style={{display:'flex',gap:8,marginBottom:10,flexWrap:'wrap'}}>
          {event.forGuests&&<span className="tag">Auch für Gäste</span>}
          {!isPast&&days<=7&&<span className="badge badge-r">Frist in {days} Tagen</span>}
          {isPast&&<span style={{fontSize:12,color:'rgba(240,234,214,.55)',fontFamily:"'Cinzel',serif"}}>VERGANGEN</span>}
        </div>
        <div className="c" style={{fontSize:20,fontWeight:700,color:'#E8C078',lineHeight:1.3,marginBottom:16}}>{event.title}</div>
        {[
          [`📅 ${fmtDate(event.date)} um ${event.time} Uhr`],
          [`📍 ${event.location}${event.address?` — ${event.address}`:''}`, event.location],
          [`⏰ Anmeldefrist: ${fmtDate(event.deadline)}`, event.deadline],
        ].filter(x=>x[1]!==false&&x[0]).map(([txt],i)=>(
          <div key={i} style={{fontSize:14,color:'rgba(240,234,214,.88)',marginBottom:6}}>{txt}</div>
        ))}
      </div>

      <div style={{padding:'0 20px'}}>
        {event.description&&(
          <div style={{marginTop:20,padding:16,background:'rgba(255,255,255,.05)',borderRadius:12,border:'1px solid rgba(201,152,74,.12)'}}>
            <p style={{fontSize:14,lineHeight:1.7,color:'rgba(240,234,214,.9)',fontStyle:'italic'}}>{event.description}</p>
          </div>
        )}

        {!isPast&&(
          <div style={{marginTop:20}}>
            <div className="sec-lbl">Meine Rückmeldung</div>
            <div style={{padding:16,background:'rgba(255,255,255,.05)',borderRadius:12,border:'1px solid rgba(201,152,74,.15)',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              {myRsvp ? (
                <div>
                  <div style={{fontSize:14,color:'#F0EAD6'}}>
                    {myRsvp.type==='yes'&&'Zugesagt'}
                    {myRsvp.type==='yes_partner'&&`Zugesagt mit ${myRsvp.partnerName||'Partnerin'}`}
                    {myRsvp.type==='yes_guest'&&`Zugesagt mit Gast: ${myRsvp.guestName}`}
                    {myRsvp.type==='maybe'&&'Vielleicht (kostenpflichtig nach Frist)'}
                    {myRsvp.type==='no'&&'Abgesagt'}
                  </div>
                </div>
              ) : (
                <div style={{fontSize:14,color:'rgba(240,234,214,.7)',fontStyle:'italic'}}>Noch keine Rückmeldung</div>
              )}
              <button onClick={()=>setShowRsvp(true)} style={{background:'rgba(201,152,74,.15)',border:'1px solid rgba(201,152,74,.35)',borderRadius:8,padding:'8px 14px',color:'#C9984A',fontFamily:"'Cinzel',serif",fontSize:11,letterSpacing:'.06em',cursor:'pointer',flexShrink:0,marginLeft:12}}>
                {myRsvp?'ÄNDERN':'ANMELDEN'}
              </button>
            </div>
          </div>
        )}

        {rsvpList.length>0&&(
          <>
            <div className="sec-lbl">Teilnehmer</div>
            {yes.length>0&&(
              <div style={{marginBottom:12}}>
                <div style={{fontSize:12,color:'#52D68A',fontFamily:"'Cinzel',serif",letterSpacing:'.08em',marginBottom:8}}>ZUSAGEN — {yes.length}</div>
                {yes.map(({member,rsvp})=>(
                  <div key={member.uid} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 0',borderBottom:'1px solid rgba(201,152,74,.06)'}}>
                    <Avatar member={member} size={32}/>
                    <div>
                      <div style={{fontSize:14,color:'#F0EAD6'}}>Br. {member.firstName} {member.lastName}</div>
                      {rsvp.type==='yes_partner'&&<div style={{fontSize:12,color:'rgba(240,234,214,.7)'}}>+{rsvp.partnerName||'Partnerin'}</div>}
                      {rsvp.type==='yes_guest'&&<div style={{fontSize:12,color:'rgba(240,234,214,.7)'}}>+Gast: {rsvp.guestName}</div>}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {maybe.length>0&&<div style={{marginBottom:12}}>
              <div style={{fontSize:12,color:'#F5CBA7',fontFamily:"'Cinzel',serif",letterSpacing:'.08em',marginBottom:8}}>VIELLEICHT — {maybe.length}</div>
              {maybe.map(({member})=><div key={member.uid} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 0'}}><Avatar member={member} size={32}/><div style={{fontSize:14,color:'rgba(240,234,214,.8)'}}>Br. {member.firstName} {member.lastName}</div></div>)}
            </div>}
            {no.length>0&&<div>
              <div style={{fontSize:12,color:'#F1948A',fontFamily:"'Cinzel',serif",letterSpacing:'.08em',marginBottom:8}}>ABSAGEN — {no.length}</div>
              {no.map(({member})=><div key={member.uid} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 0'}}><Avatar member={member} size={32}/><div style={{fontSize:14,color:'rgba(240,234,214,.7)'}}>Br. {member.firstName} {member.lastName}</div></div>)}
            </div>}
          </>
        )}
      </div>
    </div>
    {showRsvp&&<RsvpModal event={event} user={user} onSave={saveRsvp} onClose={()=>setShowRsvp(false)}/>}
    </>
  );
}

/* ═══════════════════════════════════════════════════════
   SCREEN: CREATE EVENT
═══════════════════════════════════════════════════════ */
function CreateEventScreen({user,token,onSave,onBack}){
  const [form,setForm]=useState({title:'',location:'Logensaal Loewenwolt',address:'Veerßer Str. 64, 29525 Uelzen',date:'',time:'19:00',deadline:'',forGuests:false,description:''});
  const [saving,setSaving]=useState(false);
  const [err,setErr]=useState('');
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));

  const save = async () => {
    if(!form.title||!form.date||!form.deadline){setErr('Titel, Datum und Frist sind Pflichtfelder.');return;}
    setSaving(true);
    try {
      const ev={...form,createdBy:user.uid,createdAt:nowISO(),rsvps:{}};
      const res = await dbPush('events', ev, token);
      onSave({...ev, id:res.name});
      onBack();
    } catch(e){setErr(e.message);}
    finally{setSaving(false);}
  };

  const lblStyle={fontSize:11,letterSpacing:'.1em',color:'rgba(240,234,214,.65)',marginBottom:6};

  return(
    <div className="fi" style={{padding:'0 0 80px'}}>
      <div style={{padding:'48px 20px 16px',display:'flex',gap:12,alignItems:'center'}}>
        <button onClick={onBack} style={{background:'none',border:'none',color:'rgba(201,152,74,.7)',cursor:'pointer',fontSize:20}}>←</button>
        <div className="c" style={{fontSize:18,fontWeight:700,color:'#E8C078',letterSpacing:'.06em'}}>NEUE VERANSTALTUNG</div>
      </div>
      <div style={{padding:'0 20px'}}>
        <div style={{marginBottom:14}}><div className="c" style={lblStyle}>TITEL</div><input className="lw-inp" value={form.title} onChange={e=>set('title',e.target.value)} placeholder="Name der Veranstaltung"/></div>
        <div style={{marginBottom:14}}><div className="c" style={lblStyle}>ORT</div><input className="lw-inp" value={form.location} onChange={e=>set('location',e.target.value)}/></div>
        <div style={{marginBottom:14}}><div className="c" style={lblStyle}>ADRESSE</div><input className="lw-inp" value={form.address} onChange={e=>set('address',e.target.value)}/></div>
        <div style={{display:'flex',gap:12}}>
          <div style={{marginBottom:14,flex:1}}><div className="c" style={lblStyle}>DATUM</div><input className="lw-inp" type="date" value={form.date} onChange={e=>set('date',e.target.value)}/></div>
          <div style={{marginBottom:14,flex:1}}><div className="c" style={lblStyle}>UHRZEIT</div><input className="lw-inp" type="time" value={form.time} onChange={e=>set('time',e.target.value)}/></div>
        </div>
        <div style={{marginBottom:14}}><div className="c" style={lblStyle}>ANMELDEFRIST</div><input className="lw-inp" type="date" value={form.deadline} onChange={e=>set('deadline',e.target.value)}/></div>
        <div style={{marginBottom:14}}><div className="c" style={lblStyle}>BESCHREIBUNG</div><textarea className="lw-inp" value={form.description} onChange={e=>set('description',e.target.value)} rows={3} placeholder="Optional …"/></div>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'14px 0',borderTop:'1px solid rgba(201,152,74,.1)',marginBottom:20}}>
          <div>
            <div style={{fontSize:14,color:'#F0EAD6'}}>Auch für Gäste</div>
            <div style={{fontSize:12,color:'rgba(240,234,214,.7)'}}>Gäste können sich anmelden</div>
          </div>
          <div onClick={()=>set('forGuests',!form.forGuests)} style={{width:44,height:24,background:form.forGuests?'rgba(201,152,74,.4)':'rgba(255,255,255,.1)',borderRadius:12,position:'relative',cursor:'pointer',border:`1px solid ${form.forGuests?'#C9984A':'rgba(201,152,74,.2)'}`,transition:'background .2s'}}>
            <div style={{width:18,height:18,background:form.forGuests?'#C9984A':'rgba(240,234,214,.6)',borderRadius:'50%',position:'absolute',top:2,left:form.forGuests?22:2,transition:'all .2s'}}/>
          </div>
        </div>
        {err&&<div style={{fontSize:13,color:'#F1948A',marginBottom:12}}>{err}</div>}
        <button className="lw-btn" onClick={save} disabled={saving}>{saving?'Speichern …':'Veranstaltung anlegen →'}</button>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════
   SCREEN: MEMBERS
═══════════════════════════════════════════════════════ */
function MembersScreen({members,user,setView,setSelMember}){
  const [q,setQ]=useState('');
  const filtered=members.filter(m=>`${m.firstName} ${m.lastName} ${m.city}`.toLowerCase().includes(q.toLowerCase()));
  return(
    <div className="fi" style={{padding:'0 0 80px'}}>
      <div style={{padding:'48px 20px 16px'}}>
        <div className="c" style={{fontSize:18,fontWeight:700,color:'#E8C078',letterSpacing:'.06em',marginBottom:16}}>BRÜDER</div>
        <input className="lw-inp" value={q} onChange={e=>setQ(e.target.value)} placeholder="Suchen …"/>
      </div>
      <div style={{padding:'0 20px'}}>
        <div className="sec-lbl">{filtered.length} Mitglieder</div>
        {filtered.map((m,i)=>(
          <div key={m.uid} className="card fi" style={{animationDelay:`${i*.04}s`}} onClick={()=>{setSelMember(m.uid);setView('memberDetail');}}>
            <div style={{display:'flex',alignItems:'center',gap:12}}>
              <Avatar member={m}/>
              <div style={{flex:1}}>
                <div style={{fontSize:14,fontWeight:500,color:'#F0EAD6'}}>
                  {m.title?`${m.title} `:''}Br. {m.firstName} {m.lastName}
                  {m.uid===user.uid&&<span style={{marginLeft:6,fontSize:11,color:'rgba(201,152,74,.6)',fontFamily:"'Cinzel',serif"}}>ICH</span>}
                </div>
                <div style={{fontSize:13,color:'rgba(240,234,214,.8)',marginTop:2}}>{m.city}</div>
              </div>
              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:4}}>
                <GradeBadge grade={m.grade}/>
                {m.role==='admin'&&<span className="badge badge-b" style={{fontSize:10}}>Admin</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════
   SCREEN: MEMBER DETAIL
═══════════════════════════════════════════════════════ */
function MemberDetailScreen({member,viewer,onBack}){
  const isOwn=viewer.uid===member.uid, isAdmin=viewer.role==='admin';
  const canSeePrivate=isOwn||isAdmin;
  const Row=({l,v,s=false})=>{
    if(!v||(!canSeePrivate&&s)) return null;
    return(
      <div style={{display:'flex',justifyContent:'space-between',padding:'9px 0',borderBottom:'1px solid rgba(201,152,74,.07)'}}>
        <span className="c" style={{fontSize:11,letterSpacing:'.07em',color:'rgba(201,152,74,.8)',paddingRight:12,flexShrink:0}}>{l}</span>
        <span style={{fontSize:14,color:'rgba(240,234,214,.92)',textAlign:'right'}}>{v}</span>
      </div>
    );
  };
  return(
    <div className="fi" style={{padding:'0 0 80px'}}>
      <div style={{background:'linear-gradient(180deg,#0D1F3C,#0A1628)',padding:'48px 20px 28px'}}>
        <button onClick={onBack} style={{display:'flex',alignItems:'center',gap:6,background:'none',border:'none',color:'rgba(201,152,74,.7)',fontSize:13,cursor:'pointer',marginBottom:20}}>← Zurück</button>
        <div style={{display:'flex',alignItems:'flex-start',gap:16}}>
          <Avatar member={member} size={64}/>
          <div>
            <div style={{fontSize:18,fontWeight:500,color:'#F0EAD6',marginBottom:6}}>{member.title?`${member.title} `:''}{member.firstName} {member.lastName}</div>
            <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
              <GradeBadge grade={member.grade}/>
              {member.role==='admin'&&<span className="badge badge-b">Admin</span>}
              <span className="badge badge-g">{member.status}</span>
            </div>
            {member.profession&&<div style={{fontSize:13,color:'rgba(240,234,214,.75)',marginTop:6}}>{member.profession}{member.company?` · ${member.company}`:''}</div>}
          </div>
        </div>
      </div>
      <div style={{padding:'0 20px'}}>
        <div className="sec-lbl">Kontakt</div>
        <Row l="E-MAIL" v={member.email}/>
        <Row l="MOBIL" v={member.phoneMobile}/>
        <Row l="PRIVAT" v={member.phonePrivate}/>
        <Row l="ORT" v={`${member.zip||''} ${member.city||''}`}/>
        <Row l="ADRESSE" v={member.street}/>
        <div className="sec-lbl">Loge</div>
        <Row l="GRAD" v={GRADES[member.grade]}/>
        <Row l="STATUS" v={member.status}/>
        {canSeePrivate&&<>
          <div className="sec-lbl">Persönlich · {isAdmin&&!isOwn?'sichtbar als Admin':''}</div>
          <Row l="GEBURTSDATUM" v={member.birthdate} s/>
          <Row l="GEBURTSORT" v={member.birthplace} s/>
          <Row l="PARTNER" v={member.partner} s/>
          <Row l="PARTNER GBTST." v={member.partnerBirthdate} s/>
          <div className="sec-lbl">Gradierungsdaten</div>
          {(member.gradeDates||[]).map((d,i)=>d&&<Row key={i} l={`${i+1}. GRAD`} v={d} s/>)}
        </>}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════
   SCREEN: BULLETIN (SCHWARZES BRETT)
═══════════════════════════════════════════════════════ */
function BulletinScreen({bulletins,user,token,onAdd}){
  const [showForm,setShowForm]=useState(false);
  const [form,setForm]=useState({title:'',content:'',pinned:false});
  const [saving,setSaving]=useState(false);
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));

  const submit = async () => {
    if(!form.title||!form.content) return;
    setSaving(true);
    try {
      const b={...form,authorId:user.uid,authorName:`${user.firstName} ${user.lastName}`,date:nowISO()};
      const res=await dbPush('bulletins',b,token);
      onAdd({...b,id:res.name});
      setForm({title:'',content:'',pinned:false}); setShowForm(false);
    } catch(e){alert(e.message);}
    finally{setSaving(false);}
  };

  const sorted=[...bulletins].sort((a,b)=>(b.pinned?1:0)-(a.pinned?1:0)||(new Date(b.date)-new Date(a.date)));

  return(
    <div className="fi" style={{padding:'0 0 80px'}}>
      <div style={{padding:'48px 20px 16px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <div className="c" style={{fontSize:18,fontWeight:700,color:'#E8C078',letterSpacing:'.06em'}}>PINNWAND</div>
        {user.role==='admin'&&<button onClick={()=>setShowForm(!showForm)} style={{background:'rgba(201,152,74,.15)',border:'1px solid rgba(201,152,74,.3)',borderRadius:24,padding:'7px 14px',color:'#C9984A',fontFamily:"'Cinzel',serif",fontSize:11,letterSpacing:'.06em',cursor:'pointer'}}>+ NEU</button>}
      </div>
      {showForm&&(
        <div className="fi" style={{padding:'0 20px 16px'}}>
          <div style={{padding:16,background:'rgba(255,255,255,.05)',borderRadius:14,border:'1px solid rgba(201,152,74,.2)'}}>
            <div style={{marginBottom:12}}><div className="c" style={{fontSize:11,letterSpacing:'.1em',color:'rgba(240,234,214,.65)',marginBottom:6}}>TITEL</div><input className="lw-inp" value={form.title} onChange={e=>set('title',e.target.value)} placeholder="Betreff"/></div>
            <div style={{marginBottom:12}}><div className="c" style={{fontSize:11,letterSpacing:'.1em',color:'rgba(240,234,214,.65)',marginBottom:6}}>INHALT</div><textarea className="lw-inp" value={form.content} onChange={e=>set('content',e.target.value)} rows={4}/></div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
              <span style={{fontSize:14,color:'rgba(240,234,214,.85)'}}>Anpinnen</span>
              <div onClick={()=>set('pinned',!form.pinned)} style={{width:44,height:24,background:form.pinned?'rgba(201,152,74,.4)':'rgba(255,255,255,.1)',borderRadius:12,position:'relative',cursor:'pointer',border:`1px solid ${form.pinned?'#C9984A':'rgba(201,152,74,.2)'}`,transition:'background .2s'}}>
                <div style={{width:18,height:18,background:form.pinned?'#C9984A':'rgba(240,234,214,.6)',borderRadius:'50%',position:'absolute',top:2,left:form.pinned?22:2,transition:'all .2s'}}/>
              </div>
            </div>
            <div style={{display:'flex',gap:8}}>
              <button className="lw-btn" onClick={submit} style={{flex:1,padding:'10px'}} disabled={saving}>{saving?'…':'Veröffentlichen'}</button>
              <button className="lw-btn lw-btn-o" onClick={()=>setShowForm(false)} style={{flex:1,padding:'10px'}}>Abbrechen</button>
            </div>
          </div>
        </div>
      )}
      <div style={{padding:'0 20px'}}>
        {sorted.map((b,i)=>(
          <div key={b.id} className="card card-nc fi" style={{animationDelay:`${i*.06}s`,borderColor:b.pinned?'rgba(201,152,74,.3)':'rgba(201,152,74,.15)'}}>
            <div style={{marginBottom:8}}>
              <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:4}}>
                {b.pinned&&<span style={{color:'#C9984A'}}>📌</span>}
                <span className="c" style={{fontSize:14,fontWeight:600,color:'#E8C078'}}>{b.title}</span>
              </div>
              <div style={{fontSize:12,color:'rgba(240,234,214,.65)'}}>{b.authorName} · {fmtDate(b.date)}</div>
            </div>
            <p style={{fontSize:14,color:'rgba(240,234,214,.9)',lineHeight:1.7}}>{b.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════
   SCREEN: PROFILE
═══════════════════════════════════════════════════════ */
function ProfileScreen({user,token,allMembers,onUpdate,onLogout,setView}){
  const [editing,setEditing]=useState(false);
  const [form,setForm]=useState({...user});
  const [saving,setSaving]=useState(false);
  const [toast,setToast]=useState('');
  const showToast=m=>{setToast(m);setTimeout(()=>setToast(''),2500);};
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));

  const save = async () => {
    setSaving(true);
    try {
      const {uid,role,grade,gradeDates,mustChange,...updatable}=form;
      await dbUpdate(`members/${user.uid}`, updatable, token);
      await sheetsLog('profileUpdate',{uid:user.uid,name:`${user.firstName} ${user.lastName}`,...updatable,changedAt:nowISO()});
      onUpdate({...user,...updatable});
      setEditing(false); showToast('Profil gespeichert ✓');
    } catch(e){showToast('Fehler: '+e.message);}
    finally{setSaving(false);}
  };

  const field=(lbl,fieldName,type='text',readOnly=false)=>(
    <div style={{marginBottom:14}} key={fieldName}>
      <div className="c" style={{fontSize:11,letterSpacing:'.07em',color:'rgba(201,152,74,.8)',marginBottom:6}}>{lbl}</div>
      {editing&&!readOnly
        ?<input className="lw-inp" type={type} value={form[fieldName]||''} onChange={e=>set(fieldName,e.target.value)}/>
        :<div style={{fontSize:14,color:form[fieldName]?'rgba(240,234,214,.92)':'rgba(240,234,214,.35)',padding:'10px 0',borderBottom:'1px solid rgba(201,152,74,.08)'}}>{form[fieldName]||'—'}</div>
      }
    </div>
  );

  return(
    <div className="fi" style={{padding:'0 0 80px',position:'relative'}}>
      <Toast msg={toast}/>
      <div style={{background:'linear-gradient(180deg,#0D1F3C,#0A1628)',padding:'48px 20px 28px'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
          <div style={{display:'flex',alignItems:'center',gap:14}}>
            <Avatar member={user} size={64}/>
            <div>
              <div style={{fontSize:16,fontWeight:500,color:'#F0EAD6'}}>{user.firstName} {user.lastName}</div>
              <div style={{display:'flex',gap:6,marginTop:6,flexWrap:'wrap'}}>
                <GradeBadge grade={user.grade}/>
                {user.role==='admin'&&<span className="badge badge-b">Admin</span>}
              </div>
            </div>
          </div>
          <button onClick={()=>{setEditing(!editing);setForm({...user});}} style={{background:'rgba(201,152,74,.15)',border:'1px solid rgba(201,152,74,.3)',borderRadius:8,padding:'7px 12px',color:'#C9984A',fontFamily:"'Cinzel',serif",fontSize:10,letterSpacing:'.08em',cursor:'pointer'}}>
            {editing?'ABBRECHEN':'BEARBEITEN'}
          </button>
        </div>
      </div>
      <div style={{padding:'0 20px'}}>
        <div className="sec-lbl">Kontakt</div>
        {field('E-MAIL','email','email')}
        {field('MOBIL','phoneMobile')}
        {field('TELEFON PRIVAT','phonePrivate')}
        {field('ADRESSE','street')}
        {field('ORT','city')}
        <div className="sec-lbl">Beruf</div>
        {field('BERUFSANGABE','profession')}
        {field('UNTERNEHMEN','company')}
        <div className="sec-lbl">Privat · nur für Dich & Admins sichtbar</div>
        {field('PARTNERIN','partner')}
        {field('GEBURTSTAG PARTNERIN','partnerBirthdate')}

        {editing&&<button className="lw-btn" onClick={save} disabled={saving} style={{marginTop:16}}>{saving?'Speichern …':'Änderungen speichern'}</button>}

        {user.role==='admin'&&<>
          <hr className="divider" style={{margin:'24px 0 16px'}}/>
          <div className="sec-lbl">Administration</div>
          <button className="lw-btn lw-btn-o" onClick={()=>setView('admin')} style={{marginBottom:10}}>Mitglieder & Rollen verwalten →</button>
          <button className="lw-btn lw-btn-o" onClick={()=>setView('protocols')} style={{marginBottom:10}}>Protokolle →</button>
        </>}

        <hr className="divider" style={{margin:'24px 0 16px'}}/>
        <button className="lw-btn lw-btn-r" onClick={onLogout}>Abmelden</button>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════
   SCREEN: ADMIN
═══════════════════════════════════════════════════════ */
function AdminScreen({members,token,onUpdateMember,onBack}){
  const [sel,setSel]=useState(null);
  const [toast,setToast]=useState('');
  const showToast=m=>{setToast(m);setTimeout(()=>setToast(''),2500);};

  const update = async (uid, data) => {
    try {
      await dbUpdate(`members/${uid}`, data, token);
      onUpdateMember(uid, data);
      showToast('Gespeichert ✓');
    } catch(e){showToast('Fehler: '+e.message);}
  };

  return(
    <div className="fi" style={{padding:'0 0 80px',position:'relative'}}>
      <Toast msg={toast}/>
      <div style={{padding:'48px 20px 16px',display:'flex',gap:12,alignItems:'center'}}>
        <button onClick={onBack} style={{background:'none',border:'none',color:'rgba(201,152,74,.7)',cursor:'pointer',fontSize:20}}>←</button>
        <div className="c" style={{fontSize:18,fontWeight:700,color:'#E8C078',letterSpacing:'.06em'}}>ADMINISTRATION</div>
      </div>
      <div style={{padding:'0 20px'}}>
        <div className="sec-lbl">Mitglieder ({members.length})</div>
        {members.map(m=>(
          <div key={m.uid} className="card card-nc">
            <div style={{display:'flex',alignItems:'center',gap:10}}>
              <Avatar member={m} size={38}/>
              <div style={{flex:1}}>
                <div style={{fontSize:14,color:'#F0EAD6',marginBottom:4}}>{m.firstName} {m.lastName}</div>
                <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                  <GradeBadge grade={m.grade}/>
                  <span className={`badge ${m.role==='admin'?'badge-b':m.role==='gast'?'badge-y':'badge-gold'}`} style={{fontSize:11}}>{m.role}</span>
                  <span className={`badge ${m.status==='aktiv'?'badge-g':'badge-r'}`} style={{fontSize:11}}>{m.status}</span>
                </div>
              </div>
              <button onClick={()=>setSel(sel===m.uid?null:m.uid)} style={{background:'rgba(201,152,74,.1)',border:'1px solid rgba(201,152,74,.2)',borderRadius:6,padding:'5px 10px',color:'#C9984A',fontSize:11,cursor:'pointer',fontFamily:"'Cinzel',serif"}}>
                {sel===m.uid?'—':'···'}
              </button>
            </div>
            {sel===m.uid&&(
              <div className="fi" style={{marginTop:12,padding:12,background:'rgba(0,0,0,.2)',borderRadius:8}}>
                <div style={{fontSize:11,color:'rgba(240,234,214,.65)',marginBottom:8,fontFamily:"'Cinzel',serif",letterSpacing:'.08em'}}>ROLLE</div>
                <div style={{display:'flex',gap:6,marginBottom:10}}>
                  {['admin','bruder','gast'].map(r=>(
                    <button key={r} onClick={()=>update(m.uid,{role:r})} style={{flex:1,padding:'7px',borderRadius:6,border:`1px solid ${m.role===r?'#C9984A':'rgba(201,152,74,.2)'}`,background:m.role===r?'rgba(201,152,74,.15)':'transparent',color:m.role===r?'#E8C078':'rgba(240,234,214,.7)',fontSize:12,cursor:'pointer',fontFamily:"'Cinzel',serif"}}>{r}</button>
                  ))}
                </div>
                <div style={{fontSize:11,color:'rgba(240,234,214,.65)',marginBottom:8,fontFamily:"'Cinzel',serif",letterSpacing:'.08em'}}>STATUS</div>
                <div style={{display:'flex',gap:6}}>
                  {['aktiv','inaktiv','ruhend'].map(s=>(
                    <button key={s} onClick={()=>update(m.uid,{status:s})} style={{flex:1,padding:'7px',borderRadius:6,border:`1px solid ${m.status===s?'#52D68A':'rgba(201,152,74,.2)'}`,background:m.status===s?'rgba(39,174,96,.15)':'transparent',color:m.status===s?'#52D68A':'rgba(240,234,214,.7)',fontSize:12,cursor:'pointer',fontFamily:"'Cinzel',serif"}}>{s}</button>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════
   SCREEN: PROTOCOLS
═══════════════════════════════════════════════════════ */
function ProtocolsScreen({protocols,user,onBack}){
  return(
    <div className="fi" style={{padding:'0 0 80px'}}>
      <div style={{padding:'48px 20px 16px',display:'flex',gap:12,alignItems:'center'}}>
        <button onClick={onBack} style={{background:'none',border:'none',color:'rgba(201,152,74,.7)',cursor:'pointer',fontSize:20}}>←</button>
        <div className="c" style={{fontSize:18,fontWeight:700,color:'#E8C078',letterSpacing:'.06em'}}>PROTOKOLLE</div>
      </div>
      <div style={{padding:'0 20px'}}>
        {user.role==='admin'&&<button className="lw-btn lw-btn-o" style={{marginBottom:16}}>+ Protokoll hochladen (PDF)</button>}
        {protocols.length===0&&<div style={{fontSize:14,color:'rgba(240,234,214,.65)',textAlign:'center',padding:32}}>Noch keine Protokolle vorhanden.</div>}
        {protocols.map(p=>(
          <div key={p.id} className="card card-nc">
            <div style={{display:'flex',alignItems:'center',gap:12}}>
              <div style={{width:40,height:48,background:'rgba(201,152,74,.1)',borderRadius:6,border:'1px solid rgba(201,152,74,.2)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                <span style={{fontSize:18}}>📄</span>
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:14,fontWeight:500,color:'#F0EAD6',marginBottom:3}}>{p.title}</div>
                <div style={{fontSize:12,color:'rgba(240,234,214,.7)'}}>{fmtDate(p.date)}</div>
              </div>
              <button style={{background:'rgba(201,152,74,.1)',border:'1px solid rgba(201,152,74,.2)',borderRadius:6,padding:'6px 12px',color:'#C9984A',cursor:'pointer',fontSize:13}}>↓</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════
   BOTTOM NAVIGATION
═══════════════════════════════════════════════════════ */
const NAV_TABS=[
  {id:'dashboard',lbl:'HEIM',icon:'🏠'},
  {id:'events',lbl:'TERMINE',icon:'📅'},
  {id:'members',lbl:'BRÜDER',icon:'👥'},
  {id:'bulletin',lbl:'PINNWAND',icon:'📌'},
  {id:'profile',lbl:'PROFIL',icon:'👤'},
];
const MAIN_VIEWS=['dashboard','events','eventDetail','createEvent','members','memberDetail','bulletin','profile','admin','protocols'];

function BottomNav({view,setView}){
  if(!MAIN_VIEWS.includes(view)) return null;
  const active=view==='eventDetail'||view==='createEvent'?'events':view==='memberDetail'?'members':['admin','protocols'].includes(view)?'profile':view;
  return(
    <div style={{position:'fixed',bottom:0,left:'50%',transform:'translateX(-50%)',width:'100%',maxWidth:480,background:'rgba(10,22,40,.97)',borderTop:'1px solid rgba(201,152,74,.15)',display:'flex',zIndex:100,backdropFilter:'blur(12px)'}}>
      {NAV_TABS.map(t=>(
        <button key={t.id} onClick={()=>setView(t.id)} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:3,padding:'8px 4px 16px',color:active===t.id?'#C9984A':'rgba(240,234,214,.45)',background:'none',border:'none',cursor:'pointer',transition:'color .2s',fontFamily:"'Lora',serif"}}>
          <span style={{fontSize:20}}>{t.icon}</span>
          <span style={{fontSize:9,fontFamily:"'Cinzel',serif",letterSpacing:'.08em'}}>{t.lbl}</span>
        </button>
      ))}
    </div>
  );
}

/* ═══════════════════════════════════════════════════════
   MAIN APP
═══════════════════════════════════════════════════════ */
export default function App(){
  useEffect(()=>{
    const s=document.createElement('style');
    s.textContent=CSS;
    document.head.appendChild(s);
    return()=>document.head.removeChild(s);
  },[]);

  // Auth state
  const [authData,setAuthData]=useState(null); // {idToken, localId}
  // App state
  const [user,setUser]=useState(null);
  const [members,setMembers]=useState([]);
  const [events,setEvents]=useState([]);
  const [bulletins,setBulletins]=useState([]);
  const [protocols,setProtocols]=useState([]);
  const [calEvents,setCalEvents]=useState([]);
  // UI state
  const [view,setView]=useState('login');
  const [selEvent,setSelEvent]=useState(null);
  const [selMember,setSelMember]=useState(null);
  const [loading,setLoading]=useState(false);

  // Nach Login: App-Daten laden
  const loadAppData = useCallback(async (token) => {
    setLoading(true);
    try {
      const [mems, evts, bulls, prots, cal] = await Promise.allSettled([
        dbRead('members', token),
        dbRead('events', token),
        dbRead('bulletins', token),
        dbRead('protocols', token),
        fetchCalendarEvents(),
      ]);

      if(mems.value) {
        const list = Object.entries(mems.value).map(([uid,m])=>({...m,uid}));
        setMembers(list);
      }
      if(evts.value) {
        const eList = Object.entries(evts.value).map(([id,e])=>{
          // RSVPs aus separatem Pfad nachladen (werden später async gefüllt)
          return {...e, id};
        });
        // RSVPs laden
        const rsvpData = await dbRead('rsvps', token).catch(()=>null);
        const eWithRsvp = eList.map(e=>({...e, rsvps: rsvpData?.[e.id]||{}}));
        setEvents(eWithRsvp);
      }
      if(bulls.value) setBulletins(Object.entries(bulls.value).map(([id,b])=>({...b,id})));
      if(prots.value) setProtocols(Object.entries(prots.value).map(([id,p])=>({...p,id})));
      if(cal.value) setCalEvents(cal.value);
    } catch(e){ console.error(e); }
    finally { setLoading(false); }
  }, []);

  const handleLogin = async (auth, profile) => {
    setAuthData(auth);
    if(!profile) {
      // Erstanmeldung: kein Profil in DB → Setup
      setView('setup');
      return;
    }
    setUser({...profile, uid: auth.localId});
    if(profile.mustChange) { setView('changePassword'); return; }
    await loadAppData(auth.idToken);
    setView('dashboard');
  };

  const handleSetupDone = async () => {
    // Eigenes Profil zuerst laden (jetzt garantiert vorhanden)
    const me = await dbRead(`members/${authData.localId}`, authData.idToken).catch(()=>null);
    if(me) {
      setUser({...me, uid:authData.localId});
    } else {
      // Fallback: Profil per E-Mail in members suchen
      const all = await dbRead('members', authData.idToken).catch(()=>null);
      if(all){
        const found = Object.entries(all).find(([,m])=>(m.email||'').toLowerCase()===(authData.email||'').toLowerCase());
        if(found) setUser({...found[1], uid:found[0]});
      }
    }
    await loadAppData(authData.idToken);
    setView('dashboard');
  };

  const handleChangePw = async (newToken) => {
    const updatedAuth = {...authData, idToken: newToken};
    setAuthData(updatedAuth);
    await loadAppData(newToken);
    setView('dashboard');
  };

  const handleLogout = () => {
    setAuthData(null); setUser(null);
    setMembers([]); setEvents([]); setBulletins([]); setProtocols([]);
    setView('login');
  };

  // Auto-Logout nach 10 Minuten Inaktivität
  useEffect(()=>{
    if(!authData) return;
    let timer;
    const reset = () => {
      clearTimeout(timer);
      timer = setTimeout(()=>{ handleLogout(); }, 10*60*1000); // 10 Min
    };
    const events = ['mousedown','keydown','touchstart','scroll'];
    events.forEach(e=>window.addEventListener(e, reset, {passive:true}));
    reset();
    return ()=>{
      clearTimeout(timer);
      events.forEach(e=>window.removeEventListener(e, reset));
    };
  },[authData]);

  const updateRsvp = (eventId, uid, rsvp) => {
    setEvents(es=>es.map(e=>e.id===eventId?{...e,rsvps:{...e.rsvps,[uid]:rsvp}}:e));
  };

  const wrap = {maxWidth:480,margin:'0 auto',minHeight:'100vh',background:'#0A1628',color:'#F0EAD6',position:'relative',overflow:'hidden'};

  if(!authData||view==='login') return <div style={wrap}><LoginScreen onLogin={handleLogin}/></div>;
  if(view==='setup') return <div style={wrap}><SetupScreen auth={authData} onDone={handleSetupDone}/></div>;
  if(view==='changePassword') return <div style={wrap}><ChangePasswordScreen auth={authData} onDone={handleChangePw}/></div>;
  if(loading) return <div style={wrap}><div style={{minHeight:'100vh',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}><StarLogo size={56}/><div style={{marginTop:20,fontSize:14,color:'rgba(240,234,214,.7)',fontFamily:"'Cinzel',serif",letterSpacing:'.08em'}}>LADEN …</div></div></div>;

  // Sicherheitsnetz: eingeloggt, aber Profil fehlt → kein weißer Bildschirm
  if(!user) return <div style={wrap}><div style={{minHeight:'100vh',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'0 32px',textAlign:'center'}}>
    <StarLogo size={56}/>
    <div style={{marginTop:20,fontSize:15,color:'#F0EAD6',lineHeight:1.6}}>Dein Profil konnte nicht geladen werden.</div>
    <div style={{marginTop:8,fontSize:13,color:'rgba(240,234,214,.6)',lineHeight:1.6}}>Möglicherweise wurde es beim Import nicht angelegt. Bitte abmelden und erneut anmelden.</div>
    <button className="lw-btn lw-btn-o" onClick={handleLogout} style={{marginTop:24,maxWidth:200}}>Abmelden</button>
  </div></div>;

  const token = authData.idToken;
  const currentEvent = events.find(e=>e.id===selEvent);
  const currentMember = members.find(m=>m.uid===selMember);

  return(
    <div style={wrap}>
      {view==='dashboard'&&<DashboardScreen user={user} events={events} calEvents={calEvents} bulletins={bulletins} setView={setView} setSelEvent={setSelEvent}/>}
      {view==='events'&&<EventsScreen events={events} calEvents={calEvents} user={user} setView={setView} setSelEvent={setSelEvent}/>}
      {view==='eventDetail'&&currentEvent&&<EventDetailScreen event={currentEvent} user={user} members={members} token={token} onUpdateRsvp={updateRsvp} onBack={()=>setView('events')}/>}
      {view==='createEvent'&&<CreateEventScreen user={user} token={token} onSave={ev=>setEvents(es=>[...es,ev])} onBack={()=>setView('events')}/>}
      {view==='members'&&<MembersScreen members={members} user={user} setView={setView} setSelMember={setSelMember}/>}
      {view==='memberDetail'&&currentMember&&<MemberDetailScreen member={currentMember} viewer={user} onBack={()=>setView('members')}/>}
      {view==='bulletin'&&<BulletinScreen bulletins={bulletins} user={user} token={token} onAdd={b=>setBulletins(bs=>[b,...bs])}/>}
      {view==='profile'&&<ProfileScreen user={user} token={token} allMembers={members} onUpdate={u=>setUser(u)} onLogout={handleLogout} setView={setView}/>}
      {view==='admin'&&<AdminScreen members={members} token={token} onUpdateMember={(uid,data)=>setMembers(ms=>ms.map(m=>m.uid===uid?{...m,...data}:m))} onBack={()=>setView('profile')}/>}
      {view==='protocols'&&<ProtocolsScreen protocols={protocols} user={user} onBack={()=>setView('profile')}/>}
      <BottomNav view={view} setView={setView}/>
    </div>
  );
}
